<div class="wrap">
    <div class="content" *ngFor="let name of tableNames">
        <h2>{{name}}</h2>
        <div class="general-items-table">
            <div class="column-title flex between align-center">
                <span *ngFor="let field of tableFields">{{field}}</span>
            </div>
            <div class="table-body">
                <div *ngFor="let data of table[name]; let i = index" class="table-row flex between align-center"
                    [ngClass]="{'active': isSelectedUses(data)}">
                    <div class="row-sector record-values-container" (click)="setActiveUses(i, name, data)"
                        (focusout)="blurHandler($event.target)">
                        <div class="uses-input-container">
                            <input type="text" class="uses-input" [(ngModel)]="data.Label"
                                [disabled]="!isSelectedUses(data)">
                        </div>
                        <div class="use-class-container">
                            <span *ngIf="!isSelectedUses(data)"
                                class="use-class-label">{{getUseClassLabel(data)}}</span>
                            <select class="use-class-select" [(ngModel)]='data.ClassId' *ngIf="isSelectedUses(data)">
                                <option *ngFor="let useClass of useClassOptions" [ngValue]="useClass.Id">
                                    {{useClass.Label}}</option>
                            </select>
                        </div>
                        <div class="record-errors-container">
                            <span *ngIf="!data.importErrors.length"></span>
                            <span *ngIf="data.importErrors.length" matTooltip="{{data.importErrors}}"
                                [matTooltipClass]="'tooltip-header'" class="flex between align-center popup pr05">
                                <i class="material-icons error-icon">error</i>
                            </span>
                        </div>
                    </div>
                    <div class="flex actions-container">
                        <div class="action-buttons flex between align-center">
                            <div class="icon-button-container" (click)="editUses(i, name, data)"
                                *ngIf="!isSelectedUses(data)">
                                <i class="material-icons action-icon">edit</i>
                                <span class="flex between align-center popup">Edit</span>
                            </div>
                            <div class="icon-button-container" (click)="deleteUses(i, name)"
                                *ngIf="!isSelectedUses(data)">
                                <i class="material-icons action-icon">close</i>
                                <span class="flex between align-center popup"> Delete</span>
                            </div>

                            <button mat-raised-button (click)="saveUsesModification()" [disabled]="!isValidLabelName"
                                class="action action-button" *ngIf="isSelectedUses(data)">Save
                            </button>
                            <button mat-raised-button (mousedown)="cancelUsesEdit()" *ngIf="isSelectedUses(data)"
                                class="action-button">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!tableNames.length" class="no-data">
        <h1>
            Please, upload files
        </h1>
    </div>
</div>
